export const MODULE_NAME = 'AUTH_SIGNUP_MODULE_NAME';

export const ACTION_TYPE = {
  REQUEST_PENDING: `${MODULE_NAME}.REQUEST_PENDING`,
};

export const AUTH_LOGIN_ORDER_LOCAL_STORE = 'AUTH_LOGIN_ORDER_LOCAL_STORE';

export enum FORM_VALUE_ENUM {
  NAME = 'name',
  EMAIL = 'email',
  TIMEZONE = 'timezone',
  PASSWORD = 'password',
}

export type FORM_VALUE_TYPE = `${FORM_VALUE_ENUM}`;

export interface FORM_VALUE_INTER {
  [FORM_VALUE_ENUM.NAME]: string;
  [FORM_VALUE_ENUM.EMAIL]: string;
  [FORM_VALUE_ENUM.TIMEZONE]: number;
  [FORM_VALUE_ENUM.PASSWORD]: string;
}

export const API = {
  MAIN: {
    TYPE: 'POST',
    URL: (id: number) => `/auth/signup?order=${id}`,
  },
};

export interface ACTION_RESPONSE_INTER {
  accessToken: string;
}

export interface ACTION_ERROR_INTER {
  error: string;
  message: string;
  statusCode: string;
}
